import classNames from 'classnames';
import React from 'react';
import './Card.scss';
import CardBody from './CardBody';
import CardDescription from './CardDescription';
import CardHeader from './CardHeader';

interface CardProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode | React.ReactNode[];
  overflowHidden?: boolean;
}

const Card = ({ children, overflowHidden, className, ...rest }: CardProps) => {
  return (
    <div
      className={classNames(
        'zb-card',
        {
          'zb-overflow-hidden': overflowHidden
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Description = CardDescription;

export default Card;
